

//
// Linkifies [suqare.bracket] marks to <a> tags,
// and also {curly.braces} to <span class='nestarenie-biomarker'> tags.
//

function linkify(text) {
	    if (typeof text !== 'string') return text;
    if (!text) {
        // prevent errors on null
        return '';
    }
    // text = _linkWithLinkAnchors(text)
    text = _linksWithNumberAnchors(text);

    text = text.replace(/\{([^}]+)\}/g, (match, group1) => `<span class='nestarenie-biomarker'>${group1}</span>`);

    text = text.replace(/\n/g, "<br />");
    return text;
}


function _fixURL(url) {
    url = url.trim()
    if (!url.startsWith('https://')
        && !url.startsWith('http://')) {
        url = 'https://' + url;
    }
    return url;
}


//
// "hello [link] [link] world" => "hello [1] [2] world" with <a> tags.
//
function _linksWithNumberAnchors(line) {
    let counter = 1;
    let linkMode = false;
    return line.split('').reduce((acc, char, i, arr) => {
        if (char === '[') {
            linkMode = true;
            let url = _fixURL(arr.slice(i+1, arr.indexOf(']', i)).join(''));
            return acc + `<a class="nestarenie-link" target="_blank" href="${url}">[${counter++}]</a>`;
        }
        if (char === ']') {
            linkMode = false;
            return acc;
        }
        if (!linkMode && (char !== ' ' && char !== ',')) {
            counter = 1;
        }
        return linkMode ? acc : acc + char;
    }, '');
}

function _linksWithLinkAnchors(text) {
    return text.replace(/\[((https?:\/\/)?[^\]]+)\]/g, (match, url) => {
        const initialLink = url;
        url = _fixURL(url);
        return `<a href="${url}" class="nestarenie-link" target="_blank">[${initialLink}]</a>`;  // [*] is a placeholder in the app interface, but not in PDF.
    });
}

export const Linkify = ({ text }) => {
    return <span dangerouslySetInnerHTML={{__html:linkify(text)}} />;
}
